function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { createLayout } from 'pro-layouts';
import { isPrerenderMode } from 'pro-gallery-lib';

var setAttributes = function setAttributes(node, attributes) {
  return node && attributes && Object.keys(attributes).forEach(function (attr) {
    return node.setAttribute(attr, attributes[attr]);
  });
};

var setStyle = function setStyle(node, styleProperties) {
  return node && styleProperties && Object.keys(styleProperties).forEach(function (prop) {
    var propValue = styleProperties[prop];

    if (propValue !== undefined) {
      node.style[prop] = propValue;
    } else {
      node.style.removeProperty(prop);
    }
  });
};

var getItemWrapperStyle = function getItemWrapperStyle(item, styleParams) {
  return {
    width: item.width + 'px',
    height: item.height + (styleParams.externalInfoHeight || 0) + 'px'
  };
};

var getItemContainerStyle = function getItemContainerStyle(item, styleParams) {
  var itemWrapperStyles = getItemWrapperStyle(item, styleParams);
  var isRTL = styleParams.isRTL;
  return _objectSpread({
    opacity: 1,
    top: item.offset.top + 'px',
    left: isRTL ? 'auto' : item.offset.left + 'px',
    right: !isRTL ? 'auto' : item.offset.left + 'px'
  }, itemWrapperStyles);
};

var createLayoutFixer = function createLayoutFixer() {
  if (window.layoutFixerCreated === true) {
    return;
  }

  window.layoutFixerCreated = true; //console.log('[LAYOUT FIXER] createLayoutFixer');

  var LayoutFixerElement = /*#__PURE__*/function (_HTMLElement) {
    _inheritsLoose(LayoutFixerElement, _HTMLElement);

    function LayoutFixerElement() {
      return _HTMLElement.apply(this, arguments) || this;
    }

    var _proto = LayoutFixerElement.prototype;

    _proto.connectedCallback = function connectedCallback() {
      var _this = this;

      console.log('[LAYOUT FIXER] connectedCallback');
      this.parentId = this.getAttribute('parentid');
      this.parent = this.parentNode; // && document.getElementById(this.parentId)

      console.log('[LAYOUT FIXER] parent', this.parent);
      this.useLayouter = true;
      this.items = JSON.parse(this.getAttribute('items'));

      if (!(this.items && this.items.length > 0)) {
        this.useLayouter = false;
      }

      console.log('[LAYOUT FIXER] items', this.items.map(function (item) {
        return item.mediaUrl;
      }));
      this.styleParams = JSON.parse(this.getAttribute('styles'));

      if (!(this.styleParams && typeof this.styleParams === 'object')) {
        this.useLayouter = false;
      }

      this.measures = this.parent && this.parent.getBoundingClientRect();

      if (this.measures && this.useLayouter && typeof createLayout === 'function') {
        this.layout = createLayout({
          items: this.items,
          styleParams: this.styleParams,
          container: this.measures
        });
        console.log('[LAYOUT FIXER] layout', this.layout);
      }

      if (typeof this.measures === 'object') {
        console.log('[LAYOUT FIXER] measures', this.measures);
        setAttributes(this.parent, {
          'data-top': this.measures.top,
          'data-width': this.measures.width,
          'data-height': this.measures.height
        });
      }

      if (this.useLayouter && this.layout && this.layout.items && this.layout.items.length > 0) {
        this.parent.querySelectorAll('.gallery-item-container').forEach(function (element, idx) {
          console.log('[LAYOUT FIXER] setStyle', idx, getItemContainerStyle(_this.layout.items[idx], _this.styleParams));
          setStyle(element, getItemContainerStyle(_this.layout.items[idx], _this.styleParams));
        });
        this.parent.querySelectorAll('.gallery-item-wrapper').forEach(function (element, idx) {
          setStyle(element, getItemWrapperStyle(_this.layout.items[idx], _this.styleParams));
        });
      }
    };

    return LayoutFixerElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); //console.log('[LAYOUT FIXER] customElements.define', window, window.customElements);


  window.customElements.define('layout-fixer', LayoutFixerElement);
};

if (typeof window !== 'undefined') {
  window.requestAnimationFrame(function () {
    try {
      createLayoutFixer();
    } catch (e) {
      console.error('Cannot create layout fixer', e);
    }
  });
}

export var LayoutFixer = function LayoutFixer(props) {
  console.log('[LAYOUT FIXER] rendering', isPrerenderMode(), props);
  return isPrerenderMode() ? /*#__PURE__*/React.createElement("layout-fixer", {
    parentId: props.parentId,
    items: JSON.stringify(props.items),
    styles: JSON.stringify(props.styles)
  }) : null;
};